// extracted by mini-css-extract-plugin
export default {"div":"Card_div__co9G4","img":"Card_img__NCzJD","h1":"Card_h1__YUMcH","p":"Card_p__y18gM"};